export const CLIPBOARD = {
  init: function () {
    const copyButton = document.querySelector('.js-clipboard')
    const textArea = document.querySelector('.js-clipboard-target')
    const openButton = document.querySelector('.js-clipboard-open')

    if (!copyButton || !textArea) {
      alert('コピー用ボタンまたはテキストエリアが見つかりませんでした。')
      return
    }

    copyButton.addEventListener('click', () => {
      const textToCopy = textArea.innerText

      if (navigator.clipboard && navigator.clipboard.writeText) {
        // Clipboard API の利用
        navigator.clipboard
          .writeText(textToCopy)
          .then(() => alert('テキストをコピーしました！'))
          .catch(() => alert('クリップボードにコピーできませんでした。'))
      } else {
        // フォールバック処理
        const tempTextarea = document.createElement('textarea')
        tempTextarea.value = textToCopy
        tempTextarea.style.position = 'absolute'
        tempTextarea.style.left = '-9999px'
        document.body.appendChild(tempTextarea)
        tempTextarea.select()

        try {
          if (document.execCommand('copy')) {
            alert('テキストをコピーしました！') // フォールバックでも同じメッセージ
          } else {
            alert('テキストのコピーに失敗しました。')
          }
        } catch (err) {
          alert('コピー処理中にエラーが発生しました。')
        }

        document.body.removeChild(tempTextarea)
      }
    })

    const content = document.querySelector('.p-top-petit__detail')

    openButton.addEventListener('click', () => {
      content.style.maxHeight = content.scrollHeight + 'px'
      openButton.style.display = 'none'
    })
  },
}
